import React from "react";
import { useNavigate } from "react-router-dom";
import { extractDate } from "../../Components/Functions/date.fun";
import CustomViewButton from "../../CustomComponent/custom_view_button";
const tableHead = [
  "Sr.",
  "Booking Type",
  "Customer Name",
  "Contact Number",
  "City",
  "Booking Date",
  "Actions",
];

// const getTableHead = (role) => {
//   const base = [
//     "Sr.",
//     "Name / Phone No",
//     "Department / Date",
//     "Joinig Date",
//     "Salary Expectation",
//   ];

//   if (role !== "client") {
//     base.push("Remarks");
//   }

//   base.push("Actions");

//   return base;
// };

const GetAiBookingTable = ({
  data = [],
  currentPage,
  itemsPerPage,
}) => {
  const navigate = useNavigate();
  const goToView = (id) => {
    navigate(`/get-ai-bookings/${id}`);
  };
  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead.map((item, index) => (
              <th key={index}>{item}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                <td>{item?.bookingType || "N/A"}</td>
                <td>{item?.customerName || "N/A"}</td>
                <td>{item?.contactNumber || "N/A"}</td>
                <td>{item?.city || "N/A"}</td>
                <td>{item?.bookingDate || "N/A"}</td>
                <td>
                  <CustomViewButton
                    onClick={() => goToView(item?.id)}
                  ></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default GetAiBookingTable;
